var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450.08 450.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #ab053a;\n      }\n\n      .cls-3 {\n        fill: #535450;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m450.08,87.18c0-48.15-39.03-87.18-87.18-87.18H87.18C39.03,0,0,39.03,0,87.18v127.44h450.08v-127.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m87.18,450.08h275.72c48.15,0,87.18-39.03,87.18-87.18v-148.28H0v148.28c0,48.15,39.03,87.18,87.18,87.18Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m339.24,212.99c22.8-15.88,34.21-37.06,34.21-63.12s-8.55-46.83-26.06-61.9c-17.51-15.88-41.54-23.62-72.89-23.62H97.75v306.24h176.74c32.58,0,59.05-8.15,79.82-24.03,20.77-15.88,30.95-35.02,30.95-56.61,0-35.43-15.48-61.08-46.02-76.96Zm-75.12-101.94v80.98l-85.61-80.98h85.61Zm-6.53,208.44h-81.18v-85.12h81.18c24.19,0,36.68,14.03,36.68,42.1-.78,28.99-12.49,43.03-36.68,43.03Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo_small.ca996de47fbf6d008ce8110e6be0c5d9.svg";
export { ForwardRef as ReactComponent };